var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobCostingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.13,34.85H11.41A4.92,4.92,0,0,1,6.5,29.93V11.22A4.92,4.92,0,0,1,11.41,6.3H30.13A4.92,4.92,0,0,1,35,11.22V29.93A4.92,4.92,0,0,1,30.13,34.85ZM11.41,8.48a2.74,2.74,0,0,0-2.74,2.74V29.93a2.74,2.74,0,0,0,2.74,2.74H30.13a2.74,2.74,0,0,0,2.73-2.74V11.22a2.74,2.74,0,0,0-2.73-2.74Z",
    style: {
      fill: "#62a3ef",
      stroke: "#62a3ef",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.36 25.99 10.71 24.57 16.18 18.16 22.19 22.71 28.52 14.28 30.26 15.58 22.62 25.77 16.51 21.14 12.36 25.99",
    style: {
      fill: "#62a3ef",
      stroke: "#62a3ef",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCostingIcon);
export default __webpack_public_path__ + "static/media/job_costing_icon.9dd862b2e16047b73cc88847f3a1fc20.svg";
export { ForwardRef as ReactComponent };